/* istanbul ignore file */
import type { ComponentProps } from 'react';

import { useIsSunriseTheme } from '@change-corgi/design-system-legacy/theme';

import { Callout as CalloutSunrise } from './Callout';
import { Callout as CalloutLegacy } from './CalloutLegacy';

export const Callout = (props: ComponentProps<typeof CalloutLegacy>) => {
	const isSunriseThemeEnabled = useIsSunriseTheme();

	if (isSunriseThemeEnabled) return <CalloutSunrise {...props} />;

	return <CalloutLegacy {...props} />;
};
